import React from "react";
import { Link } from "react-router-dom";
import { useSiteContent } from "../content/SiteContentContext.jsx";

const CardWithDetail = (props) => {
  const { academicDegrees } = useSiteContent();
  const items = academicDegrees.filter((val) => val.section === props.section);

  return (
    <section className="mt-8">
      <div className="mx-auto w-full max-w-[1180px] px-4 grid gap-7 grid-cols-1 ss:grid-cols-2 sm:grid-cols-3">
        {items.map((val, index) => {
          const formattedName = val.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/\s+/g, "-");

          return (
            <div className="card-modern fade-up p-7 text-left" key={val.id}>
              <div className="flex items-start gap-4">
                <span className="icon-orb w-16 h-16 flex-shrink-0">
                  <i className={`fa-solid fa-${val.icon || "graduation-cap"} text-2xl`} />
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-tPrimary leading-snug">
                    {val.name}
                  </h3>
                  {val.duration ? (
                    <span className="inline-flex items-center gap-1.5 mt-1.5 text-primary text-sm font-medium">
                      <i className="fa-regular fa-clock" /> {val.duration}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-2 mt-5">
                {val.modules ? (
                  <span className="pill pill-brand">
                    <i className="fa-solid fa-layer-group" /> {val.modules} módulos
                  </span>
                ) : null}
                <span className="pill pill-brand">
                  <i className="fa-solid fa-house-laptop" /> Presencial o en línea
                </span>
              </div>

              <div className="mt-auto pt-6">
                <Link to={`/${props.section}/${formattedName}`} className="block">
                  <button className="btn-brand w-full">
                    Más información <i className="fa-solid fa-arrow-right" />
                  </button>
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CardWithDetail;
